export interface CreateTipTapDocAgentParams {
  backendUrl: string;
  projectName: string;
  comments?: string;
  skipBlankDocument?: boolean;
}

export interface CreateTipTapDocAgentResult {
  workproductId: string;
}

export async function createTipTapDocAgent(
  params: CreateTipTapDocAgentParams
): Promise<CreateTipTapDocAgentResult> {
  const { backendUrl, projectName, comments, skipBlankDocument } = params;

  const response = await fetch(
    `${backendUrl}/api/createdocumentagentworkproduct`,
    {
      method: "POST",
      credentials: "include",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        name: projectName,
        type: "TipTap Document Agent",
        comments: comments || "",
        ...(skipBlankDocument ? { skipBlankDocument: true } : {}),
      }),
    }
  );

  if (!response.ok) {
    const t = await response.text();
    throw new Error(t || "Failed to create TipTap Document Agent workproduct");
  }

  const data = await response.json();
  const newWorkproductId: string = data.workproduct.id;

  return { workproductId: newWorkproductId };
}
